// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function CakeBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29.5 14a3.5 3.5 0 0 0-3.5-3.5h-8.5v-.258A4.509 4.509 0 0 0 20.5 6c0-3.882-3.672-5.764-3.829-5.841a1.5 1.5 0 0 0-1.342 0C15.172.236 11.5 2.118 11.5 6a4.509 4.509 0 0 0 3 4.242v.258H6A3.5 3.5 0 0 0 2.5 14v2.916c0 1.14.35 2.251 1 3.186V25A3.5 3.5 0 0 0 7 28.5h18a3.5 3.5 0 0 0 3.5-3.5v-4.898c.65-.935 1-2.047 1-3.186V14Zm-14-10.259c.157-.159.324-.308.5-.446.176.138.343.287.5.446.666.69 1 1.45 1 2.259a1.5 1.5 0 1 1-3 0c0-.809.339-1.569 1-2.259ZM5.5 14a.5.5 0 0 1 .5-.5h20a.5.5 0 0 1 .5.5v2.916c0 1.388-1.09 2.546-2.429 2.583A2.5 2.5 0 0 1 21.5 17a1.5 1.5 0 0 0-3 0 2.5 2.5 0 0 1-5 0 1.5 1.5 0 0 0-3 0 2.5 2.5 0 0 1-2.571 2.5C6.59 19.462 5.5 18.304 5.5 16.916V14ZM25 25.5H7a.5.5 0 0 1-.5-.5v-2.714a5.46 5.46 0 0 0 5.335-1.341c.057-.055.112-.113.166-.169a5.502 5.502 0 0 0 8 0c.054.056.109.114.166.169A5.457 5.457 0 0 0 24 22.5h.156a5.334 5.334 0 0 0 1.344-.214V25a.5.5 0 0 1-.5.5Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
